<div
	*ngrxLet="editor.hasFullLock() as hasFullLock"
	class="editor-header"
	[class.unlocked]="!hasFullLock"
>
	<button
		class="editor-header-lock"
		[class.unlocked]="!hasFullLock"
		(click)="editor.toggleFullLock($event)"
	>
		<mat-icon>{{ hasFullLock ? 'lock' : 'lock_open' }}</mat-icon>
	</button>
	<span class="editor-header-title">
		{{ editor.boType }} {{ editor.bo?.getQualifiedName() }}
	</span>
	<div class="editor-header-actions">
		<ng-content select="[editorFrameTopRight]"></ng-content>
		@if (editor.bo?.isModifiable) {
			<button mat-icon-button (click)="editor.save()" [disabled]="!hasFullLock">
				<mat-icon>save</mat-icon>
			</button>
		}
	</div>
</div>

<div class="content">
	<ng-content></ng-content>
</div>
